import { createReducer } from 'typesafe-actions';
import { INIT_CHAT_INFO, UPDATE_CHAT_INFO } from './actions';
import { Action, ChatInfo } from './types';

export const initialState: ChatInfo = {};

export const chat = createReducer<ChatInfo, Action>(initialState, {
  [INIT_CHAT_INFO]: () => {
    return initialState;
  },

  [UPDATE_CHAT_INFO]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  }
});
